import * as React from 'react';
import './cancelButtonHeader.module.scss';
import { routingStore } from '../../../../common/stores/routing';
import { EnhancedLocationDescriptor } from '../../../routes';
import { observer } from 'mobx-react';

type Props = {
  to: EnhancedLocationDescriptor;
};

export const CancelButtonHeader = observer(({ to }: Props) => {
  return (
    <div styleName="cancel-button-header" onClick={() => routingStore.push(to)}>
      <div styleName="button-wrapper">
        <div styleName="cancel-button-text">キャンセル</div>
        <div styleName="cancel-button-icon">×</div>
      </div>
    </div>
  );
});
